import './journey-cost.css';

const DEFAULT_TEXT = '此功能僅協助記帳與分攤，不代表平台已代為付款。';

/**
 * 記帳／分攤免責聲明（非付款流程）。
 */
export default function CostDisclaimer({ text = DEFAULT_TEXT, className = '' }) {
  return (
    <p
      className={`journey-cost-disclaimer${className ? ` ${className}` : ''}`}
      role="note"
      data-testid="cost-disclaimer"
    >
      {text}
    </p>
  );
}
